import { render, staticRenderFns } from "./ExpandedSideBar.vue?vue&type=template&id=2ebe6548&scoped=true&"
import script from "./ExpandedSideBar.vue?vue&type=script&lang=js&"
export * from "./ExpandedSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedSideBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ExpandedSideBar.vue?vue&type=style&index=1&id=2ebe6548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe6548",
  null
  
)

export default component.exports